import React from 'react'
import { Icon } from './DocumentCheck.elements'

type Props = {
  className?: string
}

export const WhiteGenericFormIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 16 16"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M3.33325 14H12.6666V4.66667L9.99992 2H3.33325V14Z" stroke="white" strokeWidth="1.33333" strokeLinejoin="round"/>
    <path d="M5.99976 8L7.33309 9.33333L9.99976 6.66666" stroke="white" strokeWidth="1.33333"/>
    <path d="M9.99976 4.66667V2L12.6664 4.66667H9.99976Z" fill="white" stroke="white" strokeWidth="1.33333" strokeLinejoin="round"/>
  </Icon>
)